import type { Player } from '../store';

/**
 * Convert the backend's lobby payload (a flat list of team names) into the
 * Player shape the view expects. The id is prefixed with `team:` so the
 * enter-animation tracker can distinguish new teams from players that were
 * already on screen.
 *
 * Note: if two teams share the same name within one game, their ids collide
 * — the enter animation fires only once and the second team silently folds
 * into the first. The backend should enforce unique (gameId, name) to avoid
 * this; tracked as a Session 32 item.
 */
export function normalizeTeams(names: string[] | undefined | null): Player[] {
  if (!Array.isArray(names)) return [];
  return names.map((name) => ({
    id: `team:${name}`,
    name,
    role: 'PLAYER' as const,
    isCaptain: false,
  }));
}
